import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { FiMoreVertical } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";

const DropdownActions = ({ actions = [] }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (open && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY + 4,
        left: rect.right + window.scrollX - 160, // largura do dropdown
      });
    }
  }, [open]);

  return (
    <div className="relative">
      <div className="relative">
        <button
          ref={buttonRef}
          onClick={(e) => {
            e.stopPropagation();
            setOpen((pv) => !pv);
          }}
          className="flex items-center justify-center h-6 w-6 rounded-full hover:bg-gray-100"
        >
          <FiMoreVertical className="text-gray-600 text-base" />
        </button>

        {typeof window !== "undefined" &&
          ReactDOM.createPortal(
            <AnimatePresence>
              {open && (
                <motion.ul
                  key="dropdown"
                  initial="closed"
                  animate="open"
                  exit="closed"
                  variants={wrapperVariants}
                  style={{
                    top: position.top,
                    left: position.left,
                    position: "absolute",
                    originY: "top",
                  }}
                  ref={dropdownRef}
                  className="flex flex-col gap-2 p-2 rounded-lg bg-white shadow-xl absolute w-40 overflow-hidden z-[9999]"
                >
                  {actions.map((action, i) => (
                    <Option
                      key={i}
                      Icon={action.icon}
                      text={action.label}
                      onClick={action.onClick}
                      setOpen={setOpen}
                    />
                  ))}
                </motion.ul>
              )}
            </AnimatePresence>,
            document.body
          )}
      </div>
    </div>
  );
};

const Option = ({ text, Icon, setOpen, onClick }) => {
  return (
    <motion.li
      variants={itemVariants}
      onClick={(e) => {
        e.stopPropagation();
        setOpen(false);
        onClick?.();
      }}
      className="flex items-center gap-2 w-full p-2 text-xs font-medium whitespace-nowrap rounded-md text-slate-700 transition-colors cursor-pointer hover:bg-[#d6c8dc] hover:text-[#3c0f55]"
    >
      <motion.span variants={actionIconVariants}>
        <Icon className="transition-colors" />
      </motion.span>
      <span>{text}</span>
    </motion.li>
  );
};

const wrapperVariants = {
  open: {
    scaleY: 1,
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
      duration: 0.2,
    },
  },
  closed: {
    scaleY: 0,
    opacity: 0,
    transition: {
      when: "afterChildren",
      staggerChildren: 0.05,
      duration: 0.2,
    },
  },
};

const itemVariants = {
  open: {
    opacity: 1,
    y: 0,
  },
  closed: {
    opacity: 0,
    y: -15,
  },
};

const actionIconVariants = {
  open: { scale: 1, y: 0 },
  closed: { scale: 0, y: -7 },
};

export default DropdownActions;
